import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { themeColorSet, ThemedText, ThemedView } from "@app/theme";
import { Image, ScrollView } from "react-native";
import { INSTANT_IMG,RUPEE_IMG,GROW_IMG } from "../Dashboard/constant";
import {CaretCircleRight} from '@sharedComponents/Icons/Icons';
import Button from "@app/sharedComponents/Button/Button";
const RenewalLearnMore =({navigation,route})=>{
    return(
        <>
        <PageHeaders pageName={route?.name} navigation={navigation} />
        <ScrollView style={{backgroundColor:themeColorSet['bg-surface-primary'],padding:16,flex:1}}>
            <ThemedText color="text-primary" variant="h5b" mb="lg">
                Benefits of loan renewal
            </ThemedText>
            <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="md" p="md" backgroundColor="bg-surface-primary" mb="lg">
                <ThemedView  flexDirection="row" alignItems="center">
                    <Image source={{uri:INSTANT_IMG}} style={{width:24,height:24}} />
                    <ThemedView flexDirection="row" alignItems="center"  ml="sm">
                        <ThemedText variant="b3m" color="text-primary">Continued access to </ThemedText>
                        <ThemedText variant="b3m" color="text-emphasis-secondary">instant funds </ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView my="lg" height={1} backgroundColor="border-primary" width={'100%'} />
                <ThemedView  flexDirection="row" alignItems="center">
                    <Image source={{uri:RUPEE_IMG}} style={{width:24,height:24}} />
                    <ThemedView flexDirection="row" alignItems="center"  ml="sm">
                        <ThemedText variant="b3m" color="text-emphasis-secondary">Avoid repayment </ThemedText>
                        <ThemedText variant="b3m" color="text-primary"> of outstanding amount </ThemedText>
                    </ThemedView>
                </ThemedView>
                <ThemedView my="lg" height={1} backgroundColor="border-primary" width={'100%'} />
                <ThemedView  flexDirection="row" alignItems="center">
                    <Image source={{uri:GROW_IMG}} style={{width:24,height:24}} />
                    <ThemedView flexDirection="row" alignItems="center"  ml="sm">
                        <ThemedText variant="b3m" color="text-emphasis-secondary">Let your portfolio grow </ThemedText>
                        <ThemedText variant="b3m" color="text-primary">& meet long term goals </ThemedText>
                    </ThemedView>
                </ThemedView>
            </ThemedView>
            <ThemedView>
                <ThemedText variant="h5b" color="text-primary" mb="lg" mx="2xs">
                    What happens if you do not renew?
                </ThemedText>
                <ThemedView flexDirection="row" mb="md" flex={1} flexShrink={1} >
                    <ThemedView>
                        <CaretCircleRight size={16} weight="fill" color={themeColorSet["icon-secondary"]} />
                    </ThemedView>
                    <ThemedText variant="b4r" color="text-secondary" ml="sm" flexShrink={1} >
                        If you prefer not to renew, please initiate a foreclosure request 5 days before your loan expires.
                    </ThemedText>
                </ThemedView>
                <ThemedView flexDirection="row" mb="md">
                    <ThemedView>
                        <CaretCircleRight size={16} weight="fill" color={themeColorSet["icon-secondary"]} />
                    </ThemedView>
                    <ThemedText variant="b4r" color="text-secondary" ml="sm" flexShrink={1}>
                        Outstanding amount to be repaid within 7 days of loan expiry
                    </ThemedText>
                </ThemedView>
                <ThemedView flexDirection="row" mb="md">
                    <ThemedView>
                        <CaretCircleRight size={16} weight="fill" color={themeColorSet["icon-secondary"]} />
                    </ThemedView>
                    <ThemedText variant="b4r" color="text-secondary" ml="sm" flexShrink={1}>
                        Portfolio will be sold off to recover outstanding amount if you fail to repay in 7 days
                    </ThemedText>
                </ThemedView>
                <ThemedView flexDirection="row" mb="md">
                <ThemedView>
                    <CaretCircleRight size={16} weight="fill" color={themeColorSet["icon-secondary"]} />
                </ThemedView>
                    <ThemedText variant="b4r" color="text-secondary" ml="sm" flexShrink={1}>
                        Penal interest @ 3% per month will be charged on outstanding amount
                    </ThemedText>
                </ThemedView>
                <ThemedView flexDirection="row" mb="md">
                    <ThemedView>
                        <CaretCircleRight size={16} weight="fill" color={themeColorSet["icon-secondary"]} />
                    </ThemedView>

                    <ThemedText variant="b4r" color="text-secondary" ml="sm" flexShrink={1}>
                        Negative impact on CIBIL score if you fail to repay
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        </ScrollView>
        <ThemedView p="lg" backgroundColor="bg-surface-primary" borderTopWidth={1} borderTopColor="border-primary">
            <Button label="Ok, got it!" handlePress={()=>navigation.goBack()} overRideStyle={{marginTop:18}}/>
        </ThemedView>
        </>
    )

}

export default RenewalLearnMore;